module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vendor-agata-location-list"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "order-vendor-information"
  }, [_c('div', {
    staticClass: "option-container main-option-container"
  }, _vm._l((_vm.locations), function(loc, i) {
    return _c('div', {
      key: i,
      staticClass: "option4",
      class: {
        'option-active': loc.ID == _vm.locationId
      },
      on: {
        "click": function($event) {
          return _vm.setWarehouse(loc)
        }
      }
    }, [_c('p', {
      class: [loc.cssClass],
      domProps: {
        "innerHTML": _vm._s(loc.City)
      }
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warehouseError === true),
      expression: "warehouseError === true"
    }],
    staticClass: "order-info-block"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Prosimy o wybór salonu z dostępnej listy.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header mb-20"
  }, [_c('i', {
    staticClass: "ion-location"
  }), _vm._v(" "), _c('h2', [_vm._v("Wybierz salon Agata Meble")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-183985ba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VendorAgataLocationList.vue
// module id = 245
// module chunks = 1